import { LoaderFunctionArgs, redirect } from "react-router-dom";
import Result from "antd/es/result";
import { Button } from "antd";
import { FormattedLeaseData } from "~/types";
import { apiClient, LeaseListLoaderResult } from "~/services/apiClient";
import { getAuth } from "firebase/auth";

export const LeaseListPageLoader = async ({ request }: LoaderFunctionArgs) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return redirect("/signup");

  const response = await apiClient.loader<LeaseListLoaderResult>("lease-table");

  if (!response.success || !response.data) {
    return {
      leaseListApproved: [] as FormattedLeaseData[],
      leaseListUnderReview: [] as FormattedLeaseData[],
      leaseListSubmitted: [] as FormattedLeaseData[],
    };
  }

  return {
    leaseListApproved: response.data.leaseListApproved,
    leaseListUnderReview: response.data.leaseListUnderReview,
    leaseListSubmitted: response.data.leaseListSubmitted,
  };
};

export type LeaseListPageLoaderType = {
  leaseListApproved: FormattedLeaseData[];
  leaseListUnderReview: FormattedLeaseData[];
  leaseListSubmitted: FormattedLeaseData[];
};

export const LeaseListPageErrorBoundary = () => {
  return (
    <Result status="500" title="500" subTitle="Sorry, something went wrong.">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href="/">
          Back Home
        </Button>
      </div>
    </Result>
  );
};
